import script from "./TaxGroups.vue?vue&type=script&setup=true&lang=js"
export * from "./TaxGroups.vue?vue&type=script&setup=true&lang=js"

import "./TaxGroups.vue?vue&type=style&index=0&id=d0dfa3ca&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d0dfa3ca"]])

export default __exports__